import type { MigrationStrategies } from "rxdb";

export const FACILITY_MIGRATION_STRATEGIES: MigrationStrategies = {
  1: (oldDoc) => {
    return oldDoc;
  },
};
